import concat from "lodash-es/concat"
import forEach from "lodash-es/forEach"
import reject from "lodash-es/reject"
import some from "lodash-es/some"

import { type TEmptyCallback } from "@/shared/types/functions"

enum ENotificationType {
    NetworkError = "networkError"
}
type TNotification = {
    id: string
    type: ENotificationType
}

type TListener = (notifications: TNotification[]) => void

class NotificationService {
    private notifications: TNotification[] = []

    private listeners: TListener[] = []

    public subscribe(listener: TListener): TEmptyCallback {
        this.listeners.push(listener)

        listener(this.notifications)

        return (): void => {
            this.listeners = reject<TListener>(this.listeners, (l: TListener): boolean => l === listener)
        }
    }

    public notify(notification: TNotification): void {
        if (some<TNotification>(this.notifications, { type: notification.type })) return

        this.notifications = concat<TNotification>(this.notifications, notification)
        this.emit()
    }

    public remove(id: string): void {
        this.notifications = reject<TNotification>(this.notifications, { id })

        this.emit()
    }

    private emit(): void {
        forEach<TListener>(this.listeners, (listener: TListener): void => listener(this.notifications))
    }
}

const notificationService: NotificationService = new NotificationService()

export { notificationService }
export { ENotificationType }
export type { TNotification, TListener }
